export const isWithinDateRange = (date, range) => {
  const isString = (value) => typeof value === "string";
  if (!isString(date)) return false;
  const sel_date = date.split(",").map((part) => part.trim());
  const today = new Date();
  const itemDate = new Date(sel_date?.[0]);

  // Error handling for invalid date input
  if (isNaN(itemDate)) {
    throw new Error("Invalid date format. Please provide a valid date.");
  }

  // Calculate the difference in days
  const diffTime = today - itemDate;
  const diffDays = diffTime / (1000 * 60 * 60 * 24);

  // Support both predefined ranges and custom day ranges
  if (typeof range === "number") {
    return diffDays <= range;
  }

  switch (range) {
    case "Last One Week":
      return diffDays <= 7;
    case "Last One Month":
      return diffDays <= 30;
    case "Last 75 Days":
      return diffDays <= 75;
    case "Above 75 Days":
      return diffDays > 75;
    default:
      throw new Error(
        "Invalid range. Supported ranges: 'Last One Week', 'Last One Month', 'Last 75 Days', 'Above 75 Days', or a number."
      );
  }
};
